import { useState, useEffect } from 'react';
import { getCategories } from 'api/community';

export const DEFAULT_ACTIVITY_TYPE = 'diving';

let cachedCategories = null;
let fetchPromise = null;

const fetchCategories = async () => {
  if (cachedCategories !== null) return cachedCategories;
  if (fetchPromise) return fetchPromise;

  fetchPromise = getCategories(DEFAULT_ACTIVITY_TYPE)
    .then((result) => {
      if (result.success && result.data) {
        cachedCategories = result.data.map((item) => ({
          value: item.code || item.value,
          label: item.name_ko || item.name || item.label,
        }));
      } else {
        cachedCategories = [];
      }
      fetchPromise = null;
      return cachedCategories;
    })
    .catch(() => {
      fetchPromise = null;
      // 실패는 캐시하지 않음 — 다음 진입 시 재요청 가능
      return [];
    });

  return fetchPromise;
};

const useCommunityCategories = () => {
  const [categories, setCategories] = useState(cachedCategories || []);
  const [isLoading, setIsLoading] = useState(!cachedCategories);

  useEffect(() => {
    if (cachedCategories !== null) {
      setCategories(cachedCategories);
      setIsLoading(false);
      return;
    }

    fetchCategories().then((data) => {
      setCategories(data);
      setIsLoading(false);
    });
  }, []);

  const categoryMap = Object.fromEntries(
    categories.map((c) => [c.value, c.label])
  );

  const categoryFilters = [
    { value: '', label: '전체' },
    ...categories,
  ];

  return { categories, categoryMap, categoryFilters, isLoading };
};

export default useCommunityCategories;
